"use client";
import type { ReactElement } from "react";
import { motion } from "framer-motion";
import { selectTimelineRulerLineModel, } from "./timeline-root-selectors";
import type { TimelinePeriod as TimelinePeriodType } from "./timeline-types";
const TIMELINE_RULER_FADE_DELAY_SECONDS = 0.2;
const TIMELINE_RULER_FADE_DURATION_SECONDS = 0.3;
export interface TimelineRulersProps {
    chartHeight: number;
    periods: TimelinePeriodType[];
    sectionBoundaryIndices: Set<number>;
}
export function TimelineRulers({ chartHeight, periods, sectionBoundaryIndices, }: TimelineRulersProps): ReactElement {
    return (<>
      {periods.map((period) => {
            const lineModel = selectTimelineRulerLineModel({
                chartHeight,
                periodGlobalIndex: period.globalIndex,
                sectionBoundaryIndices,
            });
            return (<motion.div key={`ruler-${period.globalIndex}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                    duration: TIMELINE_RULER_FADE_DURATION_SECONDS,
                    delay: TIMELINE_RULER_FADE_DELAY_SECONDS,
                    ease: "easeOut",
                }} style={{
                    position: "absolute",
                    left: lineModel.left,
                    top: 0,
                    width: 1,
                    height: lineModel.height,
                    backgroundColor: lineModel.background,
                    pointerEvents: "none",
                    zIndex: 0,
                }}/>);
        })}
    </>);
}
